module.exports = __webpack_public_path__ + "img/BELUM.8f99c969.png";